import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Grid,
  Chip,
} from "@mui/material";
import baseURL from "../../config";
import { useParams } from "react-router-dom";

const Listofcvs = () => {
  const [approvedCVs, setApprovedCVs] = useState([]);
  const [loading, setLoading] = useState(true);

  const { id: vesselownerid } = useParams();
  console.log(vesselownerid)

  // useEffect(() => {
  //   const fetchApprovedCVs = async () => {
  //     const token = localStorage.getItem("token");
  //     try {
  //       const res = await axios.get(`${baseURL}/api/crewCVuploadByCrewingAgentRoute/approved`, {
  //         headers: { Authorization: `Bearer ${token}` },
  //       });
  //       setApprovedCVs(res.data.data);
  //     } catch (error) {
  //       console.error("Error fetching approved CVs:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchApprovedCVs();
  // }, []);

  useEffect(() => {
    const fetchApprovedCVs = async () => {

      const token = localStorage.getItem("token");
      try {
        const res = await axios.get(`${baseURL}/api/crewCvAssigned/vessel-owner/${vesselownerid}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        // setApprovedCVs(res.data.data);
        setApprovedCVs(res.data.crewCVs || []);
        console.log(res.data.crewCVs)
      } catch (error) {
        console.error("Error fetching approved CVs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchApprovedCVs();
  }, [vesselownerid]);

  if (loading) return <Typography p={3}>Loading...</Typography>;

  return (
    <>
      <Box p={3}>
        <Typography variant="h4" gutterBottom fontWeight={700}>
          Approved Crew CVs
        </Typography>
        <Grid container spacing={3}>
          {approvedCVs.map((cv) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={cv._id}>
              <Card
                sx={{
                  borderRadius: 3,
                  overflow: "hidden",
                  boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
                  transition: "transform 0.25s ease-in-out, box-shadow 0.25s",
                  // padding: "10px",
                  "&:hover": {
                    transform: "scale(1.04)",
                    boxShadow: "0px 6px 28px rgba(0,0,0,0.25)",
                  },
                }}
              >
                {/* Crew Image */}
                <CardMedia
                  component="img"
                  height="220"
                  image={
                    cv.profilepicture?.filePath
                      ? `${baseURL}/${cv.profilepicture.filePath.replace(/\\/g, "/")}`
                      : "https://via.placeholder.com/200x220?text=No+Image"
                  }
                  alt={cv.name}
                  style={{
                    objectFit: "contain",
                    borderBottom: "2px solid #EFBF04", // thin gold accent
                    width: "100%",
                  }}
                />

                <CardContent sx={{ textAlign: "center" }}>
                  {/* Crew Name */}
                  <Typography
                    variant="h6"
                    fontWeight={700}
                    sx={{ mb: 1, color: "#000" }}
                  >
                    {cv.name}
                  </Typography>

                  {/*natinlity Name */}
                  {(cv.nationality && <Typography
                    variant="h6"
                    fontWeight={700}
                    sx={{ mb: 1, color: "#000" }}
                  >
                    {/* Nationality: {cv.nationality} */}
                    <span style={{ color: 'red' }}>Nationality:</span> {cv.nationality}
                  </Typography>)}

                  {/* birthdate Name */}
                  {(cv.birthdate && <Typography
                    variant="h6"
                    fontWeight={700}
                    sx={{ mb: 1, color: "#000" }}
                  >
                    {/* BirthDate:  */}
                    <span style={{ color: 'red' }}>BirthDate:</span> {cv.birthdate && new Date(cv.birthdate)
                      .toLocaleDateString("en-GB")
                      .replace(/\//g, "-")}
                  </Typography>)}


                  {/* Rank */}
                  <Chip
                    label={cv.rank}
                    sx={{
                      mb: 2,
                      fontWeight: 600,
                      fontSize: "1rem",
                      backgroundColor: "#EFBF04",
                      color: "#000",
                      display: "block",
                      mx: "auto",
                      px: 2,
                    }}
                  />

                  {/* CV Button */}
                  <Button
                    variant="contained"
                    size="small"
                    href={`${baseURL}/${cv.filePath.replace(/\\/g, "/")}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      borderRadius: 20,
                      px: 3,
                      fontWeight: 600,
                      backgroundColor: "#E8362D",
                      "&:hover": { backgroundColor: "#B22222" },
                    }}
                  >
                    Open CV
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}

        </Grid>

      </Box>
    </>
  );
};

export default Listofcvs;
